import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment-wrapper';
import { APP_DI_CONFIG } from './app-config.constants';
// AoT requires an exported function for factories
export function HttpLoaderFactory(injector) {
    var http = injector.get(HttpClient);
    return new TranslateHttpLoader(http, environment.staticResourceRoot + 'assets/i18n/', '.ng_app_version.json');
}
var ɵ0 = APP_DI_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
